import { useText } from '../i18n.js'

/**
 * Die Fußzeile mit Startseite, Impressum, Datenschutz und Handbuch.
 *
 * Sie schließt zwei Lücken auf einmal.
 *
 * Die rechtliche: Eine Anbieterkennzeichnung muss „leicht erkennbar, unmittelbar
 * erreichbar und ständig verfügbar" sein (§ 5 DDG). Solange sie nur im Fuß der
 * Startseite stand, war sie das für jemanden, der den ganzen Tag in einem Board
 * arbeitet, gerade nicht.
 *
 * Die praktische: Seit `/` bei Angemeldeten auf die Board-Übersicht umleitet,
 * kommt man an die Startseite nicht mehr durch bloßes Kürzen der Adresse. Der
 * Verweis zeigt deshalb auf die Fassung in der eingestellten Sprache — und das
 * sind genau die beiden Adressen, die **nie** weiterleiten.
 *
 * Alles hier sind volle Seitenwechsel und keine Router-Links: Es sind
 * eigenständige Dateien außerhalb der Anwendung.
 */
export function LegalFooter(): React.ReactElement {
  const t = useText()

  return (
    <footer className="brand-foot">
      <nav className="legal-links">
        {/* `start.path` und `manual.path` stehen im Wörterbuch, nicht hier: Die
            Adresse der Fassung ist Teil der Übersetzung, nicht der Ansicht. */}
        <a href={t('start.path')}>{t('legal.start')}</a>
        <a href="/impressum/">{t('legal.imprint')}</a>
        <a href="/datenschutz/">{t('legal.privacy')}</a>
        <a href={t('manual.path')}>{t('boards.manual')}</a>
      </nav>
      <p className="legal-by">
        {t('common.footer')}{' '}
        <a href="https://digitalwart.de" target="_blank" rel="noreferrer noopener">
          Digitalwart
        </a>
      </p>
    </footer>
  )
}
